import React, { memo } from 'react';
export function SolutionSection() {
  const phases = [{
    letter: 'A',
    name: 'Arranque',
    desc: 'Capturá la atención del grupo en los primeros 90 segundos.'
  }, {
    letter: 'C',
    name: 'Calentamiento',
    desc: 'Activá el cuerpo anticipando el contenido de la clase.'
  }, {
    letter: 'C',
    name: 'Cuerpo Central',
    desc: 'Desarrollá el aprendizaje motor con progresión real.'
  }, {
    letter: 'I',
    name: 'Integración',
    desc: 'Aplicá lo aprendido en un contexto lúdico o competitivo.'
  }, {
    letter: 'Ó',
    name: 'Orden y Calma',
    desc: 'Cerrá la intensidad y prepará el regreso al aula.'
  }, {
    letter: 'N',
    name: 'Nexo',
    desc: 'Convertí la clase en aprendizaje explícito y memorable.'
  }];
  return <section className="bg-white py-20 px-4" data-id="element-101">
      <div className="max-w-4xl mx-auto" data-id="element-102">
        <div className="text-center mb-16" data-id="element-103">
          <h2 className="text-3xl md:text-5xl font-extrabold text-[#0B1A2E] mb-6" data-id="element-104">
            Presentamos el{' '}
            <span className="text-[#D4A843]" data-id="element-105">Método A.C.C.I.Ó.N.</span>
          </h2>
          <p className="text-xl md:text-2xl text-gray-700 font-medium max-w-3xl mx-auto" data-id="element-106">
            El primer sistema de planificación de Educación Física diseñado
            específicamente para la realidad de las escuelas argentinas.
          </p>
        </div>

        <div className="bg-gray-50 p-8 rounded-2xl mb-12 text-lg text-gray-700 text-center border border-gray-100" data-id="element-107">
          <p data-id="element-108">
            No es un libro de juegos. No es teoría universitaria. No es un curso
            de 20 horas que nunca terminás.
          </p>
          <p className="font-bold text-gray-900 mt-4 text-xl" data-id="element-109">
            Es un sistema de 6 fases que podés aplicar en cualquier clase, con
            cualquier grupo, con o sin materiales, en cualquier espacio.
          </p>
        </div>

        <div className="grid gap-4 md:gap-6" data-id="element-110">
          {phases.map((phase, index) => <div key={index} className="flex flex-col md:flex-row items-start md:items-center bg-white border-2 border-gray-100 rounded-xl p-6 shadow-sm hover:border-[#D4A843] hover:shadow-md transition-all" data-id="element-111">
              <div className="flex items-center mb-4 md:mb-0 md:w-1/3" data-id="element-112">
                <div className="w-16 h-16 bg-[#0B1A2E] text-[#F0C14B] rounded-lg flex items-center justify-center text-3xl font-black shadow-inner flex-shrink-0" data-id="element-113">
                  {phase.letter}
                </div>
                <h3 className="text-xl md:text-2xl font-bold text-gray-900 ml-4" data-id="element-114">
                  {phase.name}
                </h3>
              </div>
              <div className="md:w-2/3 md:pl-8 md:border-l border-gray-100" data-id="element-115">
                <p className="text-lg text-gray-600" data-id="element-116">{phase.desc}</p>
              </div>
            </div>)}
        </div>

        <div className="mt-16 text-center" data-id="element-117">
          <p className="text-2xl md:text-3xl font-extrabold text-[#0B1A2E] bg-[#F0C14B]/20 inline-block px-8 py-4 rounded-xl border border-[#F0C14B]/50" data-id="element-118">
            Una estructura. Repetible. Adaptable. Tuya para siempre.
          </p>
        </div>
      </div>
    </section>;
}